/**
 * @function isTouchDevice - Checks if the device is a touch device
 * @returns {boolean} - Returns true if the device is a touch device
 */
export default isTouchDevice = () => {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
};
